import script from "./AuthenticationViewTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthenticationViewTest.vue?vue&type=script&setup=true&lang=ts"

import "./AuthenticationViewTest.vue?vue&type=style&index=0&id=3a50db07&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a50db07"]])

export default __exports__